import PersonaInfo from './persona-info.vue'
import Career from './career.vue'
import MdContent from 'components/md-content'
import CardCarousel from '../card-carousel.vue'
import Segment from 'controls/segment.vue'


const __default__ = {
  props: {
    persona: {type: Object, required: true},
    loading: {type: Boolean, default: false},
    idx: {type: Number, required: true},
    readonly: {type: Boolean, default: false},
  },
  computed: {
    info() {
      return this.persona.info
    },
    sections() {
      return this.persona.sections
    }
  },
  methods: {
    save(ext){
      this.$dispatch('document-save', {
        card_idx: this.idx,
        ext
      })
    },
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'persona',
  emits: ['follow-person'],
  setup(__props, { expose: __expose }) {
  __expose();



const __returned__ = { PersonaInfo, Career, get MdContent() { return MdContent }, CardCarousel, Segment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})